import api from './api';

export const fieldInspectionService = {
  // Get inspection reports based on type and parameters
  getInspectionReports: async (type, params = {}) => {
    let endpoint;
    switch (type) {
      case 'new-reports':
        endpoint = '/field-inspection/new_reports';
        break;
      case 'all-assigned-reports':
        endpoint = `/field-inspection/assigned_reports/${params.type}`;
        break;
      case 'unverified-reports':
        endpoint = '/field-inspection/unverified_reports';
        break;
      case 'pending-reports':
        endpoint = '/field-inspection/pending_reports';
        break;
      case 'verified-reports':
        endpoint = '/field-inspection/verified_reports';
        break;
      default:
        endpoint = '/field-inspection/new_reports';
    }
    const response = await api.get(endpoint, { params });
    
    return response.data;
  },

  // Get new inspection reports (process_inspection permission)
  getNewReports: async (params = {}) => {
    const response = await api.get('/field-inspection/new_reports', { params });
    return response.data;
  },

  getAssignedReports: async (type = 'head') => {
    const response = await api.get(`/field-inspection/assigned_reports/${type}`);
    return response.data;
  },

  // Get unverified inspection reports (process_inspection permission)
  getUnverifiedReports: async (params = {}) => {
    const response = await api.get('/field-inspection/unverified_reports', { params });
    return response.data;
  },

  // Get pending inspection reports (field-inspection permission)
  getPendingReports: async (params = {}) => {
    const response = await api.get('/field-inspection/pending_reports', { params });
    return response.data;
  },

  // Get verified reports (would need backend endpoint)
  getVerifiedReports: async (params = {}) => {
    const response = await api.get('/field-inspection/verified_reports', { params });
    return response.data;
  },

  // Get inspection report by ID
  getReportById: async (reportId) => {
    const response = await api.get(`/field-inspection/report/${reportId}`);
    return response.data;
  },

  // Get inspection reports for application
  getReportsByApplication: async (applicationId) => {
    const response = await api.get(`/field-inspection/reports/${applicationId}`);
    return response.data;
  },

  getAvailableInspectors: async (reportId) => {
    const response = await api.get(`/field-inspection/available-inspectors/report/${reportId}`);
    return response.data;
  },

  // Upload inspection report (field-inspection permission)
  uploadReport: async (reportId, reportData) => {
    const response = await api.post(`/field-inspection/upload_report/${reportId}`, reportData);
    return response.data;
  },

  // get uploaded image
  getUploadedImage: async (relPath) => {
    const response = await api.get(`/field-inspection/uploads/${relPath}`, {
      responseType: 'blob',
    });
    return response.data;
  },

  getUploadedImageUrl: (relPath) => {
    return `${api.defaults.baseURL}/field-inspection/uploads/${relPath}`;
  },

  // Assign inspection report
  assignReport: async (reportId, assignmentData) => {
    const response = await api.post(`/field-inspection/assign_report/${reportId}`, assignmentData);
    return response.data;
  },

  // Verify and forward inspection report
  verifyReport: async (reportId, verificationData) => {
    const response = {};
    if (verificationData.action === 'verify') {
      const response = await api.post(`/field-inspection/verify_forward/${reportId}`, verificationData);
      return response.data;
    } else if (verificationData.action === 'reject') {
      const response = await api.post(`/field-inspection/reject_reassign/${reportId}`, verificationData);
      return response.data;
    } else {
      throw new Error('Invalid action. Must be "verify" or "reject".');
    }
  },
};
